<template>
  <div>
    <Alert
    title="Boas-vindas! Seu painel está de cara nova."
    collapsed
    dismissible
    status="info"
    v-if="showAlert"
    >
    <template>
      <div class="d-flex">
        <p>Não se preocupe, se estiver com dúvidas, acesse a nossa</p>
        <Button
        label="seção de ajuda."
        text
        color="primary"
        class="pa-0 mt-n1 ml-1"
        small
        target="blank"
        href="https://www.locaweb.com.br/ajuda/categorias/wordpress-locaweb/"
        />
      </div>
    </template>
  </Alert>
</div>
</template>

<script>
import { Alert, Button } from '@locaweb/design-system-vue'
import VueCookies from 'vue-cookies'

export default {
  name: 'AlertNewPanel',
  components: {
    Alert,
    Button
  },
  data () {
    return {
      loginCount: parseInt(localStorage.getItem('loginCount') || 0)
    }
  },
  mounted () {
    const authorizationCookie = VueCookies.get('wordpress-panel-authorization')

    if (authorizationCookie !== null && authorizationCookie !== '') {
      localStorage.setItem('loginCount', (parseInt(localStorage.getItem('loginCount')) || 0) + 1)
      sessionStorage.setItem('isLoggedIn', true)
    }
  },
  computed: {
    showAlert () {
      return this.loginCount < 2
    }
  }
}
</script>
